import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatCard } from '@angular/material/card';
import { ButtonComponent } from '@libs/common/components';
import { AzureOAuthWebService } from '@libs/shared/auth';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'ui-agent-login',
  imports: [
    ButtonComponent,
    MatCard,
  ],
  templateUrl: './agent-login.component.html',
  styleUrl: './agent-login.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentLoginComponent {
  private readonly oauthWeb: AzureOAuthWebService = inject(AzureOAuthWebService);

  public async loginAgent(): Promise<void> {
    await firstValueFrom(this.oauthWeb.loginLlDirectoryUser());
  }
}
